import { render } from "./Contact.vue?vue&type=template&id=32a28070&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=32a28070&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32a28070"

export default script